import Icon from 'vue-awesome/components/Icon'

Icon.register({
  flare_two_tone: {
    paths: [
      {
        d: 'M5.644 7.051l1.407-1.407 2.122 2.122-1.408 1.407zM11 1h2v6h-2zm5.242 13.834l2.121 2.121-1.407 1.407-2.121-2.12zm-1.408-7.075l2.121-2.122 1.408 1.407-2.122 2.122zm-5.668 8.483l-2.122 2.12-1.407-1.406 2.122-2.122zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm-1 8h2v6h-2zM1 11h6v2H1zm16 0h6v2h-6z'
      }
    ],
    width: '24',
    height: '24'
  }
})
